const ENDPOINT_BASE_V1 = 'backoffice/v1/submerchant';

export const INVOICES_ENDPOINT = `${ENDPOINT_BASE_V1}/invoices`;
export const POLLING_ENDPOINT = `${ENDPOINT_BASE_V1}/invoices`;
export const REGISTER_ENDPOINT = `${ENDPOINT_BASE_V1}/auth/register`;
export const LOGIN_ENDPOINT = `${ENDPOINT_BASE_V1}/auth/login`;
export const REFRESH_TOKEN_ENDPOINT = `${ENDPOINT_BASE_V1}/auth/refresh_token`;
export const LOGOUT_ENDPOINT = `${ENDPOINT_BASE_V1}/auth/logout`;
export const FORGOT_PASSWORD_ENDPOINT = `${ENDPOINT_BASE_V1}/auth/forgot_password`;
export const NEW_PASSWORD_ENDPOINT = `${ENDPOINT_BASE_V1}/auth/new_password`;
export const FORGOT_PASSWORD_CHECKING_ENDPOINT = `${ENDPOINT_BASE_V1}/auth/forgot_password.check`;
export const INVITATIONS_ENDPOINT = `${ENDPOINT_BASE_V1}/invitations`;
export const TRANSACTIONS_ENDPOINT = `${ENDPOINT_BASE_V1}/transactions`;
export const INVITATION_CHECKING_ENDPOINT = `${ENDPOINT_BASE_V1}/invitations.check`;
export const VOID_TRANSACTION_ENDPOINT = `${ENDPOINT_BASE_V1}/transactions.void`;
export const GET_INVITATION_LIST_ENDPOINT = `${ENDPOINT_BASE_V1}/invitations`;
export const RESEND_INVITATION_ENDPOINT = `${ENDPOINT_BASE_V1}/invitations.resend`;
export const GET_USER_LIST_ENDPOINT = `${ENDPOINT_BASE_V1}/users`;
export const UPDATE_USER_PHONE_ENDPOINT = `${ENDPOINT_BASE_V1}/users/update.phone`;
export const UPDATE_USER_PERMISSION_ENDPOINT = `${ENDPOINT_BASE_V1}/users/update.permission`;
export const REQUEST_PHONE_FOR_EMAIL = `${ENDPOINT_BASE_V1}/users/info`;
export const GET_PERMISSIONS = `${ENDPOINT_BASE_V1}/users/get.permissions`;
export const REQUEST_OTP_REGISTER_ENDPOINT = `${ENDPOINT_BASE_V1}/otp/request.register`;
export const REQUEST_OTP_LOGIN_ENDPOINT = `${ENDPOINT_BASE_V1}/otp/request.login`;
export const REQUEST_OTP_VIA_SMS = `${ENDPOINT_BASE_V1}/otp/send.smsOtp`;
export const VERIFY_OTP_ENDPOINT = `${ENDPOINT_BASE_V1}/otp/verify`;
export const VERIFY_SMS_OTP_ENDPOINT = `${ENDPOINT_BASE_V1}/otp/verify.smsOtp`;
export const RESEND_OTP_ENDPOINT = `${ENDPOINT_BASE_V1}/otp/resend`;
export const GET_TRANSACTION_CSV_ENDPOINT = `${ENDPOINT_BASE_V1}/transactions.csv`;
export const REFUND_TRANSACTION_ENDPOINT = `${ENDPOINT_BASE_V1}/transactions.refund`;
export const UPDATE_REF2_ENDPOINT = `${ENDPOINT_BASE_V1}/transactions.references`;
export const REQUEST_REFUND_TX_ENDPOINT = `${ENDPOINT_BASE_V1}/refund.initiate`;
export const CANCEL_REFUND_TX_ENDPOINT = `${ENDPOINT_BASE_V1}/refund.cancel`;
export const REQUEST_TYPES_ENDPOINT = `${ENDPOINT_BASE_V1}/request.types`;
export const RECURRING_REQUEST_ENDPOINT = `${ENDPOINT_BASE_V1}/recurring.search`;
export const RECURRING_ENROLLMENT_REPORT_ENDPOINT = `${ENDPOINT_BASE_V1}/recurring.enrollment.report`;
export const RECURRING_ENROLLMENT_TYPE_ENDPOINT = `${ENDPOINT_BASE_V1}/reasons`;
export const RECURRING_FILE_UPLOAD_ENDPOINT = `${ENDPOINT_BASE_V1}/recurring.file.upload`;
export const RECURRING_FILE_SEARCH_ENDPOINT = `${ENDPOINT_BASE_V1}/recurring.file.search`;
export const RECURRING_ENDPOINT = `${ENDPOINT_BASE_V1}/recurring`;
export const UPDATE_RECURRING_ENDPOINT = `${ENDPOINT_BASE_V1}/recurring.update`;
export const REJECT_REASON_TYPES_ENDPOINT = `${ENDPOINT_BASE_V1}/recurring.reject.type`;
export const CANCEL_REASON_TYPES_ENDPOINT = `${ENDPOINT_BASE_V1}/recurring.cancel.type`;
export const APPROVE_RECURRING_FILE_PENDING_ENDPOINT = `${ENDPOINT_BASE_V1}/recurring.file.approve`;
export const APPROVE_RECURRING_FILE_PARTIAL_ENDPOINT = `${ENDPOINT_BASE_V1}/recurring.file.partial.approve`;
export const RECURRING_TRANSACTION_SEARCH_ENDPOINT = `${ENDPOINT_BASE_V1}/recurring.transaction.search`;
export const REJECT_RECURRING_FILE_ENDPOINT = `${ENDPOINT_BASE_V1}/recurring.file.reject`;
export const RECURRING_TRANSACTION_REPORT_ENDPOINT = `${ENDPOINT_BASE_V1}/recurring.transaction.report`;
export const RECURRING_FILE_DOWNLOAD_ENDPOINT = `${ENDPOINT_BASE_V1}/recurring.file.download`;
export const RECURRING_APPROVED_FILE_CHECKLIST = `${ENDPOINT_BASE_V1}/recurring.file.validations`;
